import React, { memo, useCallback, useState } from 'react';
import Box from '@mui/material/Box';

import { Sidebar, Header, Footer } from '../../layout-components';
import {
    HEADER_HEIGHT,
    SIDEBAR_WIDTH_VAR,
    SIDEBAR_COLLAPSED_WIDTH,
    SIDEBAR_MOTION
} from '../../layout-components/layoutConstants';

const H = `${HEADER_HEIGHT}px`;
const W = SIDEBAR_WIDTH_VAR;
/** Closed, the sidebar keeps its section icons, so the page starts after the
 *  rail rather than at the window edge. */
const RAIL_W = `${SIDEBAR_COLLAPSED_WIDTH}px`;

const LeftSidebar = ({ children = <></> }: { children?: React.ReactNode }) => {
    // kinda weird - false means open, true means closed
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const sidebarToggle = useCallback(() => {
        setSidebarOpen((prev) => !prev);
    }, []);
    // While the sidebar edge is dragged the page follows the pointer directly;
    // the open/close animation would make it trail behind.
    const [sidebarResizing, setSidebarResizing] = useState(false);

    return (
        <>
            <Header sidebarToggle={sidebarOpen} setSidebarToggle={sidebarToggle} />
            <Sidebar
                sidebarToggle={sidebarOpen}
                setSidebarToggle={sidebarToggle}
                setSidebarCollapsed={setSidebarOpen}
                sidebarResizing={sidebarResizing}
                onSidebarResizingChange={setSidebarResizing}
            />
            <Box
                component="main"
                sx={{
                    marginTop: H,
                    marginLeft: { lg: sidebarOpen ? RAIL_W : W },
                    minHeight: `calc(var(--app-vh, 100vh) - ${H})`,
                    display: 'flex',
                    flexDirection: 'column',
                    // The page background belongs to the app frame, not to each
                    // section: a route registered outside its section's router
                    // (Escorted Tours is) would otherwise fall through to the
                    // body colour and read as a different-looking page.
                    backgroundColor: 'grey.100',
                    // Only the margin moves. `all` also animated the background
                    // and every inherited property, which is what made one
                    // toggle look like several things happening at once.
                    transition: sidebarResizing ? 'none' : `margin-left ${SIDEBAR_MOTION}`
                }}
            >
                <Box sx={{ flexGrow: 1, minHeight: 0 }}>{children}</Box>
                <Footer />
            </Box>
        </>
    );
};

export default memo(LeftSidebar);
